(ns assemble.component.file-tree.hooks
  (:require [uix.core :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

;; TODO: This might not be needed later, if the asset-type property is passed
;; down from the routing, depending on the selected view (Brand kit page).
(defhook use-active-asset-type []
  (let [parent-node-ids (use-subscribe [:assemble.page.assets.file-tree/parent-node-ids])
        root-id (second parent-node-ids)
        root-node (use-subscribe [:assemble.page.assets.file-tree/get-item root-id])]
    (keyword (:asset-tree/folder-type root-node))))
